import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../login/login.service';
import { firstValueFrom } from 'rxjs';

/**
 * Routeguard that checks if you are allowed to access pages after username + password login, but WITHOUT pin login.
 */
@Injectable()
export class MfaAuthenticatedGuardService {
  private _initiallyRefreshed: boolean = false;

  constructor(
    private _loginService: LoginService,
    private _router: Router
  ) {
  }

  /**
   * Method that checks if allowed.
   */
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // attempt to refresh access token, if we haven't already (during startup of portal)
    if (!this._initiallyRefreshed) {
      this._initiallyRefreshed = true;
      this._loginService.setSessionData({});
      const result = await firstValueFrom(this._loginService.refreshAccessToken$());
      if (!result) {
        this._router.navigateByUrl('/login');
        return false;
      }
    }
    if (this._loginService.isMfaAuthenticated) {
      return true;
    }

    this._router.navigateByUrl('/');
    return false;
  }

  /**
   * Method that checks if allowed.
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    return this.canActivate(route, state);
  }
}
